import axios from 'axios'

export const AXIOS = axios.create({
  // baseURL: `/api`,
  baseURL: `/api`,
  withCredentials: true
})



// WEBPACK FOOTER //
// ./src/scripts/http-common.js